// Renders backend deal-QA errors in the shopper's language (falls back to the English message).
export const qaText = (t, e) => {
  if (!e) return "";
  if (typeof e === "string") return e;
  const key = e.code ? `qa.${e.code}` : null;
  if (!key) return e.message || "";
  const translated = t(key, e.params || {});
  return translated === key ? (e.message || "") : translated;
};

// A 400/402 response body -> one readable sentence.
export const qaDetailText = (t, detail) => {
  if (!detail) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail.errors)) return detail.errors.map((e) => qaText(t, e)).join(" ");
  return qaText(t, detail);
};
